import { $get } from '@/src/request';
import { getCSDomainHost } from '@/src/utils/host';

export const MineURL = {
  MINE: 'v1/userinfo/getMyPageModule', // 获取我的页面数据
  SETTINGS: 'v1/userinfo/getMyPageSettingModule', // 获取设置页数据
  SETUSERINFO: 'v1/userinfo/setUserInfo', // 设置用户信息
  USERADDRESSLIST: 'v1/address/user/getAllAddressInUserV2', // 地址列表
  DELUSERADDRESS: 'v1/address/user/delete', // 删除地址
  MINEBUBBLECLICK: 'v1/userinfo/userClickEvent', // 个人中心气泡点击上报
  SSOCHECK: 'v1/sso' //sso鉴权接口
};

export async function mineRequest(url = '', data = {}, params = {}, headers = {}, showLoading = true, fingerprint = false): Promise<any> {
  // @ts-ignore
  const networkModule = Mach.requireModule('Network');
  const requestParams = {
    url,
    method: 'POST',
    params,
    data,
    headers
  };
    // @ts-ignore
  const indicatorModule = Mach.requireModule('ActivityIndicator');
  if (showLoading) {
    indicatorModule.showLoading();
  }
  return new Promise<any>((resolve, reject) => {
    const callback = (result: any) => {
      if (showLoading) {
        indicatorModule.hideLoading();
      }
      if (result.error) {
        console.log(`mine request api error: ${JSON.stringify(result.error)}`);
        reject(result.error);
      } else {
        console.log('mine request api success!', url);
        if (result.data && result.data.code === 0) {
          resolve(result.data.data);
        } else {
          const errMsg = result.data.msg || result.data.message;
          console.log(`mine request api error: ${errMsg}`);
          // Toast.show(errMsg || '请求异常，请重试', 2);

          const code = result.data.code || 0;
          const extraInfo = {
            msg: errMsg,
            url,
            method: 'mineRequest'
          };
          const errInfo = {
            code,
            message: errMsg,
            extraInfo
          };
          reject(errInfo);
        }
      }
    };
    if (fingerprint) {
      networkModule?.requestWx?.(requestParams, callback);
    } else {
      networkModule?.request?.(requestParams, callback);
    }
  });
}

// 根据环境获取客服 host
export const getPageHost = () => {
  const SLCommon = Mach.requireModule('SLCommon');
  const { env, swimlane } = SLCommon?.getEnv?.() || {};
  const isProd = !Mach.env.isDebug || env === 'Stage' || env === 'Prod';

  if (isProd) {
    return env === 'Stage' ? 'https://cs.mykeeta.st.sankuai.com' : 'https://cs.mykeeta.com';
  }
  const swimlaneName = swimlane?.name ? `${swimlane?.name}-sl-` : '';
  return `https://${swimlaneName}cs.mykeeta.test.sankuai.com`;
};

/**
 * 获取客服未读消息数
 */
export async function getCustomerUnreadMsgCount(params): Promise<any> {
  const host = getCSDomainHost();
  const [, res] = await $get({
    url: `${host}/csapi/chat/message/count`,
    data: {
      ...(params || {}),
    },
  });
  return res;
}
